module.exports = __webpack_public_path__ + "static/kartchen2-ef41b70a19c019ef69ff631a2259a9c5.png";